import { UserAnimatedPhoto } from 'components/content/memory/animatedPhoto/AnimatedPhoto'
import { SDot, SDotsContainer } from 'components/dots/DotsContainer'
import { Icon } from 'components/icon'
import { SelectedMemory } from 'components/memory/MemoryUtils'
import { useState } from 'react'
import {
  SLeftButton,
  SMemoriesCarousel,
  SMemoryContentWrapper,
  SRightButton,
} from './MemoryCarousel.styled'

export function UserMemoryCarousel(props: { memories?: SelectedMemory[]; isPublic?: boolean }) {
  const [index, setIndex] = useState(0)
  const memory = props?.memories?.[index]

  const iterate = (direction: 'left' | 'right') => {
    if (!props.memories) return
    if (direction === 'left') {
      index <= 0 ? setIndex(props.memories.length - 1) : setIndex(index - 1)
    } else {
      index >= props.memories.length - 1 ? setIndex(0) : setIndex(index + 1)
    }
  }

  const hideNavigation = !props.memories || props.memories.length <= 1

  return (
    <SMemoriesCarousel>
      <SMemoryContentWrapper>
        <SLeftButton
          css={{ visibility: hideNavigation ? 'hidden' : 'visible' }}
          onClick={() => iterate('left')}
        >
          <Icon name="ChevronRight" size="1rem" />
        </SLeftButton>

        <UserAnimatedPhoto memory={memory} isPublic={props.isPublic} />

        {!hideNavigation && (
          <SRightButton onClick={() => iterate('right')}>
            <Icon name="ChevronRight" size="1rem" />
          </SRightButton>
        )}
      </SMemoryContentWrapper>

      {!hideNavigation && (
        <SDotsContainer css={{ marginTop: '1rem' }}>
          {props?.memories?.map((_, i) => (
            <SDot key={i} isActive={i === index} onClick={() => setIndex(i)} />
          ))}
        </SDotsContainer>
      )}
    </SMemoriesCarousel>
  )
}
